<template>
  <div class="container-fluid">
    <TheHeader :stationName="viewName" />
    <div class="ps-4 pe-4 pt-3">
      <JBoxForm :station-id="stationId" :table-url="tableUrl"></JBoxForm>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import TheHeader from "@/components/layouts/TheHeader.vue";
import JBoxForm from "@/components/jBox/JBoxForm.vue";

const stationId = 35;
const viewName = "J-Box";
const tableUrl = `/Material/GetLastJBox?num=6`;

onMounted(() => {
  document.title = viewName;
});
</script>
